import { Checkbox, Stack, Typography } from "@mui/material";
import React from "react";

type Props = {
  label: string;
  ariaLabel: string;
  value: boolean;
  onChange: (value: boolean) => void;
};

export const ConfirmationCheckbox = ({ label, ariaLabel, value, onChange }: Props) => {
  return (
    <Stack direction="row">
      <Checkbox
        value={value}
        onChange={(e) => onChange(e.target.checked)}
        sx={{ ml: "-12px", mr: 1 }} // @note: ml: "-12px" to align with the text
        slotProps={{
          input: {
            "aria-label": ariaLabel,
          },
        }}
      />

      <Typography variant="body1" sx={{ fontWeight: "bold" }}>
        {label}
      </Typography>
    </Stack>
  );
};
